import React, { lazy, Suspense } from "react";
import Theme1 from "./Theme1";
import { Spinner } from "reactstrap";

// Theme mapping object for dynamic rendering
const THEME_COMPONENTS = {
  Theme1: Theme1,
};

// Dynamic Theme Renderer
const ThemeRenderer = ({ themeKey, orgInfo, orgData }) => {
  const SelectedTheme = THEME_COMPONENTS[themeKey];

  if (!SelectedTheme) {
    console.warn(`No theme found for: ${themeKey}`);
    return null;
  }

  return (
    <Suspense fallback={<Spinner />}>
      <SelectedTheme orgInfo={orgInfo} orgData={orgData} />
    </Suspense>
  );
};

export { ThemeRenderer, Theme1 };
